import { gql, useQuery } from '@apollo/client';
import { CUSTOMER_ACCOUNT_FIELDS, CUSTOMER_OPERATION_LOG_FIELDS } from '../types/CustomerManagementTypes';
import type { CustomerAccountType, CustomerOperationLogPage } from '../types/CustomerManagementTypes';

export const GET_CUSTOMER_ACCOUNTS = gql`
    query CustomerAccounts($channelId: Long!) {
        customerAccounts(channelId: $channelId) {
            ...CustomerAccountFields
        }
    }
    ${CUSTOMER_ACCOUNT_FIELDS}
`;

export const GET_CUSTOMER_OPERATION_LOGS = gql`
    query CustomerOperationLogs($channelId: Long!, $operationType: String, $page: Int!, $size: Int!) {
        customerOperationLogs(channelId: $channelId, operationType: $operationType, page: $page, size: $size) {
            content {
                ...CustomerOperationLogFields
            }
            totalElements
            page
            size
        }
    }
    ${CUSTOMER_OPERATION_LOG_FIELDS}
`;

interface CustomerAccountsResponse {
    customerAccounts: CustomerAccountType[];
}

interface CustomerOperationLogsResponse {
    customerOperationLogs: CustomerOperationLogPage;
}

export const useCustomerAccounts = (channelId: number | null) => {
    return useQuery<CustomerAccountsResponse>(GET_CUSTOMER_ACCOUNTS, {
        variables: { channelId: channelId! },
        skip: !channelId,
        fetchPolicy: 'network-only',
    });
};

export const useCustomerOperationLogs = (
    channelId: number | null,
    operationType: string | null,
    page: number,
    size: number
) => {
    return useQuery<CustomerOperationLogsResponse>(GET_CUSTOMER_OPERATION_LOGS, {
        variables: { channelId: channelId!, operationType, page, size },
        skip: !channelId,
        fetchPolicy: 'network-only',
    });
};
